module.exports = __webpack_public_path__ + "f6d80daf6b5888e47d287e5def8b784a.png";